<div class="sp-row__align">
  <img
    class="sp-flag sp-margin__right"
    [src]="country_prefix?.flag" />
  <div class="sp-column">
    <p class="sp-flag__label sp-color__primary sp-text__ellipsized">
      {{ country_prefix?.name || 'N/A' }}
    </p>
    <p class="sp-flag__text sp-text__ellipsized">
      {{ country_prefix?.prefix || '-' }}
    </p>
  </div>
</div>
